import {
  ADSTERRA_SMARTLINK_URL,
  ADSTERRA_POPUNDER_SCRIPT_URL,
  ADSTERRA_SOCIAL_BAR_SCRIPT_URL,
} from './adsterraConfig';

/**
 * Handles all Adsterra ad triggering.
 * Ad execution happens here and only from explicit user gestures.
 * Scripts are never injected on page load.
 */
class AdsterraAdapter {
  constructor() {
    this._injectedScripts = new Set();
  }

  /**
   * @param {'smartlink'|'popunder'|'social-bar'} mode
   * @returns {{ success: boolean, mode: string, error?: string }}
   */
  async triggerAd(mode = 'smartlink') {
    try {
      if (mode === 'smartlink') {
        const popup = window.open(ADSTERRA_SMARTLINK_URL, '_blank', 'noopener,noreferrer');
        if (!popup) {
          return { success: false, mode, error: 'popup_blocked' };
        }
        return { success: true, mode };
      }

      if (mode === 'popunder') {
        this._injectScriptOnce(ADSTERRA_POPUNDER_SCRIPT_URL);
        return { success: true, mode };
      }

      if (mode === 'social-bar') {
        this._injectScriptOnce(ADSTERRA_SOCIAL_BAR_SCRIPT_URL);
        return { success: true, mode };
      }

      return { success: false, mode, error: 'unsupported_mode' };
    } catch (err) {
      return { success: false, mode, error: err?.message ?? 'unknown_error' };
    }
  }

  _injectScriptOnce(src) {
    if (this._injectedScripts.has(src)) return;
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    document.body.appendChild(script);
    this._injectedScripts.add(src);
  }
}

// Singleton — one adapter instance for the whole session
export const adsterraAdapter = new AdsterraAdapter();
